import { FC } from 'react';
import ConversationHandler from '../Components/Conversation/ConversationHandler';


export const PageChat: FC = () => {
    return <>

        <ConversationHandler />

    </>;
};
